import { profileUrl } from "../api/endpoints.js";
import getFetchWrapper from "../api/getFetchWrapper.js";
const mutationFnFactory = (config, keyProps) => {
  const fetchWrapper = getFetchWrapper(config);
  return ({ profile }) => {
    return fetchWrapper(profileUrl, {
      method: "PATCH",
      body: JSON.stringify({
        account: {
          "cipher.accountId": keyProps.accountId,
          accountIdType: keyProps.accountIdType
        },
        profile
      })
    });
  };
};
export { mutationFnFactory as default };
//# sourceMappingURL=mutation.js.map
